import Axios from "axios";
import { ICountry } from "src/types/country.types.ts";

export class CountryServices {
  public static async getAmazonCountries(): Promise<ICountry[]> {
    const { data } = await Axios.get("/api/v1/countries/amazon");
    return data;
  }
}
